import { ProductContext } from "./ProductContext";
import { Designation } from "./elements/Designation";
import { ShortDescription } from "./elements/ShortDescription";
import { PrimaryImage } from "./elements/PrimaryImage";
import { PreferredIndicator } from "./elements/PreferredIndicator";
import { PrimaryImageWithLogos, PrimaryImageWithLogosV2 } from "./elements/PrimaryImageWithLogos";
import { FullDesignation } from "~/feature/Product/elements/FullDesignation";
import { PdpLink } from "~/feature/Product/elements/PdpLink";
import { DescriptionV2 } from "./elements/DescriptionV2";
import { ShortDescriptionV2 } from "./elements/ShortDescriptionV2";
import { DesignationV2 } from "./elements/DesignationV2";
import { PrimaryImageV2 } from "./elements/PrimaryImageV2";
import { DesignationContainer } from "./elements/DesignationContainer";
import { MMDChip } from "./elements/MMDChip";

export const Product = {
  PdpLink,
  DesignationContainer,
  Designation,
  DesignationV2,
  /**
   * @deprecated - use v2 instead
   */
  ShortDescription,
  ShortDescriptionV2,
  DescriptionV2,
  PrimaryImage,
  PrimaryImageV2,
  PreferredIndicator,
  PrimaryImageWithLogos,
  PrimaryImageWithLogosV2,
  FullDesignation,
  Context: ProductContext,
  MMDChip,
};
